import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["countdown"];
  static values = { duration: Number };


  connect() {
    console.log("Timer connected!"); // Debugging
    this.endTime = Date.now() + this.durationValue * 1000;
    this.updateTimer();
  }


   updateTimer() {
    const remaining = Math.max(0, Math.ceil((this.endTime - Date.now()) / 1000));
    this.countdownTarget.textContent = remaining;

    if (remaining > 0) {
      setTimeout(() => this.updateTimer(), 1000);
    } else {
      this.countdownTarget.textContent = "Time's Up!";
    }
  }

}
